import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`


.ingredient-data{
    display: flex;
    align-items: center;
    justify-content: start;
    gap:1rem;

    input{
    
        width: 25px !important;
        height: 25px !important;
        accent-color: var(--primary);
    }
    h5{
        color:var(--text) ;
        font-size: 2rem;
        font-weight: 500;

    }
    img{
        width: 25px;
        height: 25px;
        border-radius: 50%;
    }
}

.categories-model-ingredient-container{
  

    .categories-container{
        display: grid;
        grid-template-columns: auto auto;
        gap: 2rem;
        padding: 2rem;
            overflow-y: auto;
    height: 400px;

    }
}

.popup-title{
    width: 100%;
    text-align: center; 
    margin-top: 4rem;

    h1{
        font-weight: 600;
    }
}

.close-button{
    top:-18px;
      @media (max-width:  768px) {
       top:-5px;
      }
}

.custom-scrollbar{
    overflow-y: auto !important;
}
`
export const StyledReactModal = styled(ReactModal)`
height: 700px;
overflow: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      right: auto;
      bottom: auto;
      margin: auto;
      transform: translate(-50%, -50%);
      font-size: 2rem;
     
      border-radius: 2rem;
      background-color: white;
      @media (max-width:  768px) {
        width: 90%;
        height: auto;
      }

`;